module.exports = __webpack_public_path__ + "static/busy-week-messy-desk-3b4b1a83f253a22969532ceb906da3d8.jpg";